import React, { ReactNode } from 'react';
import { Checkbox, Form, Space, Spin } from 'antd';
import { LoadingOutlined } from 'antd/icons';
import { css } from '@emotion/react';
import { SessionForm } from '@components/Clinicians/session-form';
import { SessionFormItem } from './SessionFormItem';

const ClinicalCheckbox = ({
  field,
  label,
  disabled,
  helpLink = null,
  isSaving = false,
  onChange
}: {
  field: keyof SessionForm;
  label: string;
  disabled: boolean;
  helpLink?: ReactNode;
  isSaving?: boolean;
  onChange: ({ field, value }: { field: keyof SessionForm; value: boolean }) => void;
}) => {
  return (
    <SessionFormItem key={`${field}-form-item`} label={label}>
      <Space>
        <Form.Item name={field} valuePropName="checked">
          <Checkbox
            data-testid={`${field}-checkbox`}
            disabled={disabled}
            onChange={({ target }) => onChange({ field, value: target.checked })}
            aria-label={label}
          />
        </Form.Item>
        <Spin
          indicator={
            <LoadingOutlined
              css={css`
                font-size: 14px;
                margin-left: 4px;
                visibility: ${isSaving ? 'visible' : 'hidden'};
              `}
              spin
            />
          }
        />
        {helpLink && (
          <div
            css={css`
              margin-left: 24px;
            `}
          >
            {helpLink}
          </div>
        )}
      </Space>
    </SessionFormItem>
  );
};

export default ClinicalCheckbox;
